import type { PaymentAccountingEventKey } from './schemas';
import type { SafeString } from './strings';

const PAYMENT_ENTRY_TYPE_PREFIX = 'payment';

export const makePaymentEntryTypePrefix = (
  paymentType: SafeString
): SafeString =>
  // Both halves are SafeStrings and `_` is not a delimiter character, so the
  // concatenation is a SafeString without a runtime re-parse.
  `${PAYMENT_ENTRY_TYPE_PREFIX}_${paymentType}_` as SafeString;

type MakePaymentEntryTypeParams = {
  paymentType: SafeString;
  event: PaymentAccountingEventKey;
};

/**
 * Creates a derived 'type' for a payment entry.
 *
 * This is needed because payment entries have no explicit type,
 * the type exists on the payment itself, and then there are different
 * entries for each event.
 *
 * This result is meant to be opaque, no one should try to decompose it.
 */
export const makePaymentEntryType = ({
  paymentType,
  event,
}: MakePaymentEntryTypeParams): SafeString =>
  `${makePaymentEntryTypePrefix(paymentType)}${event}` as SafeString;
